var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "연간 교육 계획 목록",
          tableId: "table",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          gridHeightAuto: "",
          checkClickFlag: false,
          isExcelDown: true,
        },
        on: { linkClick: _vm.linkClick },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }